// SVG geometry retained under the MIT license in LICENSE.txt.
import React from 'react';
import { SvgIcon } from '../primitives';
const ArrowUpward = React.forwardRef(function ArrowUpward(props, ref) {
    return <SvgIcon {...props} ref={ref}><path d="m4 12 1.41 1.41L11 7.83V20h2V7.83l5.58 5.59L20 12l-8-8-8 8z"/></SvgIcon>;
});
export default ArrowUpward;
